<div
  class="current-status-item grow"
  [ngClass]="{
    closed: statusState === statusStates.CLOSED,
    complete: statusState === statusStates.COMPLETED,
    closedandcomplete: statusState === statusStates.CLOSED_COMPLETE,
    inprogress: statusState === statusStates.INPROGRESS
  }"
  [class.removedash-after]="_isLast === true"
  [class.removedash-before]="_itemIndex === 1"
>
  <div
    class="status-item-content"
    tabindex="0"
    [ngClass]="{
      closed: statusState === statusStates.CLOSED,
      complete: statusState === statusStates.COMPLETED,
      closedandcomplete: statusState === statusStates.CLOSED_COMPLETE,
      inprogress: statusState === statusStates.INPROGRESS,
      burialclosed: burialSeasonClosed
    }"
    (mouseenter)="setStatus()"
    (mouseleave)="setBurialClosedStatus()"
    (focusout)="hideIcon()"
  >
    <ds-icon
      *ngIf="
        (statusState === statusStates.COMPLETED ||
          statusState === statusStates.CLOSED_COMPLETE) &&
        showIcon
      "
      [name]="'check'"
      [color]="'white'"
    ></ds-icon>
    <div>
      <div
        *ngIf="
          !(
            statusState === statusStates.COMPLETED ||
            statusState === statusStates.CLOSED_COMPLETE
          ) || !showIcon
        "
        [innerHTML]="getContent()"
        (mouseenter)="setStatus()"
        (mouseleave)="setBurialClosedStatus()"
      ></div>
    </div>
  </div>
</div>
